import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=10f4e74f&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=10f4e74f&prod&lang=css&"
import style1 from "./Detail.vue?vue&type=style&index=1&id=10f4e74f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports